import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import EmptyState from '@atlaskit/empty-state';
import { defineMessages, useIntl } from '@atlassian/jira-intl';
import { expVal } from '@atlassian/jira-feature-experiments';

const messages = defineMessages({
	emptyStateTextGalaxia: {
		id: 'home-project-recommendations.empty-state-text-galaxia.non-final',
		defaultMessage: 'Any recommended spaces will appear here',
		description:
			'Empty state description text shown when there are no recommended spaces to display',
	},
	emptyStateHeaderGalaxia: {
		id: 'home-project-recommendations.empty-state-header-galaxia.non-final',
		defaultMessage: 'No spaces found',
		description: 'Empty state heading shown when there are no recommended spaces to display',
	},
	emptyStateText: {
		id: 'home-project-recommendations.empty-state-text.non-final',
		defaultMessage: 'Any recommended projects will appear here',
		description:
			'Empty state description text shown when there are no recommended projects to display',
	},
	emptyStateHeader: {
		id: 'home-project-recommendations.empty-state-header.non-final',
		defaultMessage: 'No projects found',
		description: 'Empty state heading shown when there are no recommended projects to display',
	},
});

const styles = cssMap({
	emptyStateStyles: {
		textAlign: 'center',
		color: token('color.text'),
		paddingTop: token('space.025'),
		paddingBottom: token('space.025'),
		paddingLeft: token('space.0'),
		paddingRight: token('space.0'),
		width: '100%',
	},
});

export const RecommendedProjectsEmptyState = (): React.ReactElement => {
	const { formatMessage } = useIntl();
	const emptyStateTextGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? messages.emptyStateTextGalaxia
		: messages.emptyStateText;
	const emptyStateHeaderGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? messages.emptyStateHeaderGalaxia
		: messages.emptyStateHeader;

	return (
		<Box xcss={styles.emptyStateStyles}>
			<EmptyState
				description={formatMessage(emptyStateTextGalaxia)}
				header={formatMessage(emptyStateHeaderGalaxia)}
			/>
		</Box>
	);
};
